import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';

// TypeScript interfaces
interface ContainerProps {
  hubSelection: string;
}

export const Container = styled('div')<ContainerProps>`
  align-items: ${(props) =>
    props.expanded?.toString() === 'true' ? 'left' : 'center'};
  border-right: 1px solid ${colours.neutral[200]};
  box-sizing: border-box;
  display: flex;
  height: 100%;
  padding: 15px;
  width: ${(props) =>
    props.expanded?.toString() === 'true' ? '280px' : 'fit-content'};

  @media (max-width: ${breakpoints.laptop}) {
    background: rgba(41, 41, 39, 0.7);
    display: flex;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    max-width: unset;
    min-width: unset;
    padding: 0;
    visibility: ${(props) =>
      props.expanded?.toString() === 'true' ? 'visible' : 'hidden'};
    width: 100%;
    z-index: 200;
  }
`;

export const InnerContainer = styled('div')`
  align-items: ${(props) =>
    props.expanded?.toString() === 'true' ? 'left' : 'center'};
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  overflow: auto;
  width: 100%;

  @media (max-width: ${breakpoints.laptop}) {
    background-color: ${colours.neutral[100]};
    box-sizing: border-box;
    box-shadow: 0px 12px 50px 0px rgba(0, 0, 0, 0.5);
    height: 100%;
    max-width: 400px;
    padding: 15px;
    width: 90%;
  }
`;

export const PanelHeader = styled('div')`
  align-items: ${(props) =>
    props.expanded?.toString() === 'true' ? 'center' : 'center'};
  box-sizing: border-box;
  display: flex;
  justify-content: ${(props) =>
    props.expanded?.toString() === 'true' ? 'space-between' : 'center'};
  gap: 15px;
  height: 60px;
`;

export const PanelHeaderLogo = styled('div')`
  align-items: center;
  border-radius: 100px;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: 60px;
  padding: 10px 17px;

  img {
    height: 22px;
  }
`;

export const Navigation = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const OpenMenu = styled('div')`
  display: none;

  @media (max-width: ${breakpoints.laptop}) {
    align-items: center;
    background-color: ${colours.neutral[100]};
    border-bottom: 0.5px solid ${colours.neutral[300]};
    box-sizing: border-box;
    color: black;
    cursor: pointer;
    display: flex;
    gap: 5px;
    left: 0;
    padding: 20px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
  }
`;
